import React from 'react';

import SinglePackingItem from './SinglePackingItem';
import PackingMarketplaceBarcode from '../PackingMarketplaceBarcode';

const SinglePacking = (props) => {
  const {
    barcode,
    measurements,
    requirements,
    palletBarcode,
    items,
    isOpen,
    onTogglePacking,
    data,
    num,
  } = props;

  return (
    <div className="packing-main">
      <div className="packing-top">
        <div style={{ marginRight: '10px' }}>
          <div style={{ fontWeight: '500' }}>{`${
            typeof num !== 'undefined' ? '#' + num + ' | ' : '# '
          }${barcode}`}</div>
          {measurements ? (
            <div style={{ marginLeft: '10px' }} className="parameters">
              <span>{`ШхВхГ: ${measurements.dimensions.width / 10} x ${
                measurements.dimensions.height / 10
              } x ${measurements.dimensions.depth / 10} cм`}</span>
              <span style={{ marginLeft: '8px' }}>{`Вес: ${measurements.weight} г`}</span>
            </div>
          ) : null}
        </div>

        <div className="d-flex">
          <div className="pallet-barcode">
            {palletBarcode ? `Паллета: #${palletBarcode}` : null}
          </div>

          <div className="show-packing-info-button" onClick={onTogglePacking}>
            <div>Позиции</div>
            <i className={!isOpen ? 'fe-eye' : 'fe-eye-off'} />
          </div>
        </div>
      </div>

      <PackingMarketplaceBarcode {...props} type="packing" />

      {isOpen && items?.length ? (
        <div className="packing-items">
          {items.map((item, i) => (
            <SinglePackingItem
              key={`${item.productId}-${item.variantId}-${i}`}
              {...props}
              item={item}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default SinglePacking;
